import * as React from 'react';
import classnames from 'classnames';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import { sanitizeGenericHtml } from 'utils/sanitize';

import './campaign-timeline-overview-step.scss';

type Props = {
  type: 'common' | 'initial-tick' | 'initial' | 'final',
  text: string,
  value?: string,
  date?: string,
  mainClass?: string
};

const CampaignTimelineOverviewStep: React.FC<Props> = ({
  type,
  text,
  value,
  date,
  mainClass
}): JSX.Element => {
  const renderValue = (): React.ReactNode => {
    if (value) {
      return value;
    }

    if (type === 'initial-tick') {
      return (
        <SVGDynamicIcon
          name="checkmark-custom-fg"
          width={12}
          height={12}
          customColor="white"
        />
      );
    }

    return '';
  };

  const textClasses = classnames('campaign-timeline-overview-step__text', {
    'campaign-timeline-overview-step__text--final': type === 'final'
  });

  const numberContainerClasses = classnames('campaign-timeline-overview-step__number-container', {
    'campaign-timeline-overview-step__number-container--initial-tick': type === 'initial-tick',
    'campaign-timeline-overview-step__number-container--initial': type === 'initial',
    'campaign-timeline-overview-step__number-container--final': type === 'final'
  });

  const numberClasses = classnames('campaign-timeline-overview-step__number', {
    'campaign-timeline-overview-step__number--initial-tick': type === 'initial-tick',
    'campaign-timeline-overview-step__number--final': type === 'final'
  });

  const numberSpanClasses = classnames('campaign-timeline-overview-step__number-span', {
    'campaign-timeline-overview-step__number-span--icon': type === 'initial-tick'
  });

  const dateClasses = classnames('campaign-timeline-overview-step__date', {
    'campaign-timeline-overview-step__date--final': type === 'final'
  });

  const classes = classnames('campaign-timeline-overview-step', mainClass);

  return (
    <div className={classes}>
      <div className="campaign-timeline-overview-step__contents">
        <div
          className={textClasses}
          dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(text) }}
        />
        <div className={numberContainerClasses}>
          <div className={numberClasses}>
            <span className={numberSpanClasses}>
              {renderValue()}
            </span>
          </div>
        </div>
        {
          date && (
            <div className={dateClasses}>
              {date}
            </div>
          )
        }
      </div>
    </div>
  );
};

export default CampaignTimelineOverviewStep;
